import { render, staticRenderFns } from "./SeOchLyssna.vue?vue&type=template&id=28e1e470&scoped=true&"
import script from "./SeOchLyssna.vue?vue&type=script&lang=js&"
export * from "./SeOchLyssna.vue?vue&type=script&lang=js&"
import style0 from "./SeOchLyssna.vue?vue&type=style&index=0&id=28e1e470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e1e470",
  null
  
)

export default component.exports